import React from "react";
import theuz from "../theuz/imgTheuz/theuz.png";
import "./p-t.css";

function Terms() {
  return (
    <>
      <header className="header-t-p">
        <div className="header-tp-container">
          <a href="/">
            <img src={theuz} alt="" />
          </a>
        </div>
      </header>
      <main>
        <section className="tp-section">
          <h1>Termos de Uso (THEUZ SOLUTIONS)</h1>

          <p>
            Estes Termos de Uso ("Termos") regem o uso do website e dos serviços
            digitais oferecidos pela THEUZ SOLUTIONS, empresa focada em
            desenvolvimento de Websites, SEO e Aplicativos Móveis.
          </p>

          <h2>1. Aceitação dos Termos</h2>
          <p>
            Ao acessar e utilizar nosso website ou solicitar nossos serviços, o
            usuário concorda em cumprir e ser regido por estes Termos. Se você
            não concordar com qualquer parte dos Termos, não deve utilizar
            nossos serviços.
          </p>

          <h2>2. Serviços Oferecidos</h2>
          <ul>
            A THEUZ SOLUTIONS fornece serviços de:
            <li>Desenvolvimento e design de Websites e Landing Pages.</li>
            <li>Desenvolvimento de Aplicativos Mobile (iOS e Android).</li>
            <li>Consultoria e otimização para motores de busca (SEO).</li>
          </ul>

          <h2>3. Propriedade Intelectual</h2>
          <p>
            <strong>Conteúdo do Site:</strong> Todo o conteúdo presente neste
            website (textos, gráficos, logotipos, ícones, SVGs e a compilação do
            software) é de propriedade exclusiva da THEUZ SOLUTIONS ou de seus
            licenciadores e é protegido pelas leis de direitos autorais.
          </p>
          <p>
            <strong>Projetos de Clientes:</strong> A propriedade intelectual de
            todo o código, design e conteúdo criados especificamente para um
            cliente sob contrato será transferida ao cliente após a quitação
            integral dos valores acordados. A THEUZ SOLUTIONS pode reter o
            direito de exibir o projeto em seu portfólio, salvo acordo em
            contrário.
          </p>

          <h2>4. Deveres e Responsabilidades do Usuário</h2>
          <p>
            O usuário deve fornecer informações verdadeiras, precisas e
            completas ao solicitar orçamentos ou iniciar um projeto.
          </p>
          <p>
            É proibido utilizar o site para: violar leis; realizar atividades
            ilícitas; enviar vírus ou códigos destrutivos; ou interferir na
            segurança ou integridade do website.
          </p>

          <h2>5. Orçamentos e Contratação</h2>
          <p>
            A solicitação de orçamento (cotação) por meio do e-mail de contato
            não constitui um contrato ou compromisso de compra.
          </p>
          <p>
            A contratação de qualquer serviço é formalizada mediante a aceitação
            de uma Proposta Comercial específica e a assinatura de um Contrato
            de Prestação de Serviços separado, que regerá os detalhes, prazos e
            pagamentos do projeto.
          </p>

          <h2>6. Limitação de Responsabilidade</h2>
          <p>
            A THEUZ SOLUTIONS não se responsabiliza por quaisquer danos ou
            prejuízos diretos ou indiretos decorrentes do uso (ou incapacidade
            de uso) do website ou dos serviços, exceto conforme expressamente
            previsto no contrato de serviço firmado com o cliente.
          </p>

          <h2>7. Alterações nos Termos</h2>
          <p>
            A THEUZ SOLUTIONS se reserva o direito de modificar estes Termos a
            qualquer momento. As alterações entrarão em vigor imediatamente após
            a publicação no website. Recomendamos que os usuários revisem esta
            página periodicamente.
          </p>
        </section>
      </main>
    </>
  );
}

export default Terms;
